import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

type ButtonProps = {
  label: string;
  href: string;
  variant: "primary" | "secondary" | "ghost";
  fullWidth?: boolean;
  style?: ResponsiveStyleProps;
};

export function ButtonLinkBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<ButtonProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Label</Label>
          <Input
            className="h-8 text-xs"
            value={props.label ?? ""}
            onChange={(e) => setProp((p) => { p.label = e.target.value; })}
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Link</Label>
          <Input
            className="h-8 text-xs"
            value={props.href ?? ""}
            onChange={(e) => setProp((p) => { p.href = e.target.value; })}
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Style</Label>
          <Select
            value={props.variant ?? "primary"}
            onValueChange={(v) => setProp((p) => { p.variant = v as ButtonProps["variant"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="primary">Primary</SelectItem>
              <SelectItem value="secondary">Secondary</SelectItem>
              <SelectItem value="ghost">Ghost</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center justify-between">
          <Label className="text-xs">Full width</Label>
          <Switch
            checked={props.fullWidth ?? false}
            onCheckedChange={(v) => setProp((p) => { p.fullWidth = v; })}
          />
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showBackground={false} />;
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
